var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolvaxion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 705.8889 197.0803",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "fullLogo",
    d: "M63.4598,98.7768c-5.0265,4.8544-12.5908,6.0742-19.3181,6.6666-3.3429,.2925-6.7551,.4738-10.1109,.4582,0,0-18.9134-.2326-32.2023-5.0021v-6.7427c14.6764,4.9281,31.4478,5.2025,31.4478,5.2025,11.4959,0,20.0725-1.1246,23.8452-4.3587,2.748-2.3497,3.9575-6.0076,1.9743-9.3027-1.4517-2.4162-4.89-3.499-7.4149-4.2022-1.2573-.3534-36.6591-8.4143-36.9743-8.5004-4.1008-1.1391-8.437-2.327-11.4456-5.5874-1.2667-1.3717-2.3495-3.3166-2.827-5.1217-1.2538-4.7471,.2649-10.0955,3.8299-13.5435,5.0272-4.8551,12.5915-6.0778,19.318-6.6666,3.3429-.2925,6.756-.4738,10.1119-.4582,0,0,16.6116,.0857,28.2386,3.2341v6.6535c-13.7535-3.5365-27.4876-3.3418-27.4876-3.3418-11.4959,0-20.0725,1.1235-23.8452,4.3576-2.748,2.3497-4.0114,5.8487-2.0282,9.1465,1.4551,2.4162,4.9474,3.6551,7.4843,4.4061,2.3148,.6816,36.4403,8.3477,36.9751,8.4972,4.0974,1.1362,8.3667,2.1238,11.3742,5.3806,1.2704,1.3717,2.353,3.3202,2.8307,5.1253,1.2547,4.7432-.2068,10.2541-3.7761,13.6996Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "fullLogo-2",
    "data-name": "fullLogo",
    d: "M153.7782,73.1706v1.1908c-.4107,20.4671-15.7335,27.0317-17.4812,27.7133-6.3991,2.4991-13.5623,3.7532-21.9001,3.8329-8.3378-.0829-15.501-1.3338-21.9001-3.8329-1.7445-.6816-17.0673-7.2462-17.4812-27.7102v-1.1876c.4107-20.4834,15.7335-27.0385,17.4812-27.7165,6.3959-2.4991,13.5623-3.7504,21.9001-3.8301,8.341,.0797,15.5074,1.331,21.9033,3.8301,1.7445,.6781,17.0673,7.2331,17.478,27.7102Zm-7.1727,.592c-.0223-5.9914-1.6204-11.2508-4.6195-15.2112-6.9371-9.1529-19.5982-10.5186-26.5258-10.5186h-2.1234c-6.9275,0-19.5888,1.3689-26.5259,10.5218-2.9989,3.9604-4.597,9.2198-4.6193,15.2112,.0191,5.9949,1.6173,11.254,4.6193,15.2112,6.9371,9.1561,19.5984,10.5221,26.5259,10.5221h2.1234c6.9275,0,19.5887-1.3692,26.5258-10.5221,3.0022-3.9572,4.6004-9.2195,4.6195-15.2144Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "fullLogo-3",
    "data-name": "fullLogo",
    d: "M171.6112,98.5155V42.5592h-6.8998l-.0073,62.3631h58.3638v-6.4031l-51.4568-.0036Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "fullLogo-4",
    "data-name": "fullLogo",
    d: "M283.0671,42.5954l-26.352,51.6635c-1.5156,2.9695-3.43,4.224-5.1232,4.224s-3.6076-1.2509-5.1195-4.224l-26.3557-51.6635h-7.7446l27.951,54.7997c3.7781,7.4001,8.6837,8.5096,11.2688,8.5096,2.5888,0,7.4908-1.1095,11.2653-8.5096l27.9546-54.7997h-7.7446Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "fullLogo-5",
    "data-name": "fullLogo",
    d: "M335.1946,49.992c-3.7781-7.2878-8.6801-8.3755-11.2689-8.3755-2.5851,0-7.4908,1.0914-11.2652,8.3755l-28.4839,54.9339h7.7446l9.2493-17.8387h45.5105l9.2457,17.8387h7.7483l-28.4804-54.9339Zm-30.7537,30.7863l14.3617-27.7044c1.5192-2.9224,3.4336-4.1515,5.1232-4.1515,1.6932,0,3.6077,1.2291,5.1232,4.1515l14.3652,27.7044h-38.9733Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "fullLogo-6",
    "data-name": "fullLogo",
    d: "M527.2664,43.2801h6.9052v62.3638h-6.9052V43.2801Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "fullLogo-7",
    "data-name": "fullLogo",
    d: "M623.8284,73.4155v1.1908c-.4107,20.4671-15.7335,27.0317-17.4812,27.7133-6.3991,2.4991-13.5623,3.7532-21.9001,3.8329-8.3378-.0829-15.501-1.3338-21.9001-3.8329-1.7445-.6816-17.0673-7.2462-17.4812-27.7102v-1.1876c.4107-20.4834,15.7335-27.0385,17.4812-27.7165,6.3959-2.4991,13.5623-3.7504,21.9001-3.8301,8.341,.0797,15.5074,1.331,21.9033,3.8301,1.7445,.6781,17.0673,7.2331,17.478,27.7102Zm-7.1727,.592c-.0223-5.9914-1.6204-11.2508-4.6195-15.2112-6.9371-9.1529-19.5982-10.5186-26.5258-10.5186h-2.1234c-6.9275,0-19.5888,1.3689-26.5259,10.5218-2.9989,3.9604-4.597,9.2198-4.6193,15.2112,.0191,5.9949,1.6173,11.254,4.6193,15.2112,6.9371,9.1561,19.5984,10.5221,26.5259,10.5221h2.1234c6.9275,0,19.5887-1.3692,26.5258-10.5221,3.0022-3.9572,4.6004-9.2195,4.6195-15.2144Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "fullLogo-8",
    "data-name": "fullLogo",
    d: "M705.8889,43.312v57.4067c0,3.8237-2.1712,5.1543-3.104,5.5459-.3789,.1593-1.0123,.3597-1.8115,.3597-1.1685,0-2.6997-.4235-4.3265-2.0119l-54.9046-52.9053v53.959h-6.902V48.2432c0-3.8233,2.1712-5.1511,3.104-5.5456,.9328-.3948,3.4-1.019,6.1379,1.6521l54.9046,53.0388V43.312h6.902Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logoMark"
  }, /*#__PURE__*/React.createElement("a", {
    xlinkHref: 66.618431372549
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "logoMark_PathItem_",
    "data-name": "logoMark &lt;PathItem&gt;",
    points: "447.5093 105.5725 539.0188 197.0803 584.4472 197.0803 470.2243 82.8592 447.5093 105.5725",
    style: {
      fill: "#cf2027"
    }
  })), /*#__PURE__*/React.createElement("a", {
    xlinkHref: 66.618431372549
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "logoMark_PathItem_-2",
    "data-name": "logoMark &lt;PathItem&gt;",
    points: "531.4244 0 470.2252 61.2028 447.5098 38.4875 485.9973 0 531.4244 0",
    style: {
      fill: "#cf2027"
    }
  })), /*#__PURE__*/React.createElement("a", {
    xlinkHref: 66.618431372549
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "logoMark_PathItem_-3",
    "data-name": "logoMark &lt;PathItem&gt;",
    points: "413.9679 72.033 459.3951 72.033 397.4018 134.0226 351.9747 134.0226 413.9679 72.033",
    style: {
      fill: "#cf2027",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("a", {
    xlinkHref: 66.618431372549
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "logoMark_PathItem_-4",
    "data-name": "logoMark &lt;PathItem&gt;",
    points: "413.9643 72.0294 341.9386 0 387.3657 0 459.3951 72.0294 413.9643 72.0294",
    style: {
      fill: "#cf2027",
      fillRule: "evenodd"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolvaxion);
export default __webpack_public_path__ + "static/media/solvaxion.5cf7db19df1308fda05cd5b9a169cb76.svg";
export { ForwardRef as ReactComponent };